import { format, fromUnixTime } from 'date-fns';
import React, { useState } from 'react';
import capitalizeFirstLetter from '../../common/functions/capitalize.first.letter';
import translate from '../../common/functions/translate';
import { usePageView } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/use.page.title';
import DisplayAccountInfo from './display.account.info';
import EnterUserInfoSection from './enter.user.info.section';
import NoAccountInRecords from './no.account.in.records';

export default function FindMyAccount() {
    const [page, setPage] = useState(0);
    const [userName, setUserName] = useState('');
    const [createdAt, setCreatedAt] = useState(0);
  
    usePageTitle(capitalizeFirstLetter(translate('Find My Account').toLowerCase()));
    usePageView('Find my account');
   
    const convertToDate = (timestamp) => {
        const date = fromUnixTime(timestamp);
        return format(date, 'MM/dd/yyyy');
    };
   
    const enterUserInfoSection = <EnterUserInfoSection
        showPageCallBack={(code) => setPage(code)}
        setUserName={setUserName}
        setCreatedAt={setCreatedAt}
    ></EnterUserInfoSection>;
    const displayAccountInfo = <DisplayAccountInfo userName={userName} createdAt={convertToDate(createdAt)} />;
    const noAccountInRecords = <NoAccountInRecords/>;
   
    const pages = [enterUserInfoSection, displayAccountInfo, noAccountInRecords];
   
    return pages[page];
}